import LocalizedStrings from "react-localization";
import en from "./en";
import tr from "./tr";
import ru from "./ru";
import ar from "./ar";
import { DropdownItem } from "../components/Dropdown/types";

export const dictionary = new LocalizedStrings({
  en,
  tr,
  ru,
  ar,
  currentLanguage: "tr",
});

export const languageOptions: DropdownItem[] = [
  {
    key: "tr",
    value: "Türkçe",
    icon: <i className="fi fi-tr"></i>,
  },
  {
    key: "en",
    value: "English",
    icon: <i className="fi fi-us"></i>,
  },
  {
    key: "ru",
    value: "русский",
    icon: <i className="fi fi-ru"></i>,
  },
  {
    key: "ar",
    value: "عربي",
    icon: <i className="fi fi-sa"></i>,
  },
];
